import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b9cb0284"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home pb-5" }
const _hoisted_2 = { class: "img-container" }
const _hoisted_3 = {
  key: 0,
  class: "container-lg container-fluid",
  id: "scroll-to"
}
const _hoisted_4 = { class: "row body" }
const _hoisted_5 = { class: "col-lg-8 bg-white pt-5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, " Summary of Data on The Botswana Health Innovation Management System ", -1))
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "mt-5 mb-3"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex h-100 align-items-center justify-content-center py-5 shadow-sm" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, " No available innovation data or Error getting innovation data ")
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "col-lg-4 side py-3" }
const _hoisted_15 = { class: "card bg-transparent border-0" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-center" }, "Highlighting Innovation Impact", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "Feedbacks from Batswana", -1))
const _hoisted_18 = {
  key: 1,
  class: "container-lg container-fluid mt-lg-3 mt-3"
}
const _hoisted_19 = { class: "row d-flex h-100 align-items-center" }
const _hoisted_20 = { class: "col-lg-8" }
const _hoisted_21 = { class: "d-flex justify-content-evenly mb-3" }
const _hoisted_22 = { class: "col-lg-4" }
const _hoisted_23 = { class: "feedbacks" }
const _hoisted_24 = { class: "feedback_module" }
const _hoisted_25 = { class: "feedback_button" }
const _hoisted_26 = { class: "shadow-lg bg-white p-3 slide_in_out rounded-2" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-12" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "title" }, [
  /*#__PURE__*/_createTextVNode("Title"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-2" }, "*")
], -1))
const _hoisted_30 = { class: "mb-3 m_w_input" }
const _hoisted_31 = { class: "col-12" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, [
  /*#__PURE__*/_createTextVNode("Description "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_33 = { class: "col-12" }
const _hoisted_34 = { class: "p-float-label prime_input" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "author" }, "Name(S)", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WelcomeScreen = _resolveComponent("WelcomeScreen")!
  const _component_WelcomeImageLoader = _resolveComponent("WelcomeImageLoader")!
  const _component_BoxOverview = _resolveComponent("BoxOverview")!
  const _component_Chart = _resolveComponent("Chart")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_CardList = _resolveComponent("CardList")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Carousel = _resolveComponent("Carousel")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("section", _hoisted_2, [
      _createVNode(_component_WelcomeScreen, {
        onLoaded: _ctx.onImgLoad,
        welcomeDetail: _ctx.Welcome
      }, null, 8, ["onLoaded", "welcomeDetail"])
    ], 512), [
      [_vShow, _ctx.isLoaded]
    ]),
    _withDirectives(_createVNode(_component_WelcomeImageLoader, null, null, 512), [
      [_vShow, !_ctx.isLoaded]
    ]),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_BoxOverview, {
                data: _ctx.tileData,
                background: false
              }, null, 8, ["data"]),
              _createElementVNode("section", _hoisted_7, [
                _createVNode(_component_Chart, {
                  type: "bar",
                  data: _ctx.analyticsData,
                  options: _ctx.option,
                  height: 100
                }, null, 8, ["data", "options"])
              ]),
              (_ctx.loadMore)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_Skeleton, {
                      width: "100%",
                      style: {"height":"15rem"},
                      class: "mb-2"
                    }),
                    _createVNode(_component_Skeleton, {
                      width: "100%",
                      style: {"height":"15rem"}
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_ctx.innovationList?.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.innovationList, (item) => {
                            return (_openBlock(), _createBlock(_component_CardList, {
                              key: item.id,
                              body: item,
                              card: _ctx.cardListStyle,
                              route: `/partners/partner-on-proposal/${item.id}?id=${item.id}`
                            }, null, 8, ["body", "card", "route"]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.innovationList?.length <= 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                      : _createCommentVNode("", true)
                  ])),
              (_ctx.PaginationData.total_records > 0)
                ? (_openBlock(), _createBlock(_component_Paginator, {
                    key: 2,
                    rows: _ctx.PaginationData.size,
                    totalRecords: _ctx.PaginationData.total_records,
                    onPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onPage($event)))
                  }, null, 8, ["rows", "totalRecords"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_Carousel, {
                  value: _ctx.TestimonialsData,
                  numVisible: 3,
                  numScroll: 1,
                  orientation: "vertical",
                  verticalViewPortHeight: "350px",
                  style: {"width":"100%","margin-top":"0.5rem","padding":"0.5rem","background-color":"transparent"}
                }, {
                  header: _withCtx(() => [
                    _hoisted_16,
                    _hoisted_17
                  ]),
                  item: _withCtx((slotProps) => [
                    _createVNode(_component_Card, {
                      body: slotProps.data,
                      card: _ctx.cardStyle
                    }, null, 8, ["body", "card"])
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("section", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_Skeleton, {
                  style: {"height":"15rem"},
                  width: "10rem",
                  class: "mx-2"
                }),
                _createVNode(_component_Skeleton, {
                  style: {"height":"15rem"},
                  width: "10rem",
                  class: "mx-2"
                }),
                _createVNode(_component_Skeleton, {
                  style: {"height":"15rem"},
                  width: "10rem",
                  class: "mx-2"
                }),
                _createVNode(_component_Skeleton, {
                  style: {"height":"15rem"},
                  width: "10rem",
                  class: "mx-2"
                })
              ]),
              _createVNode(_component_Skeleton, {
                width: "100%",
                style: {"height":"15rem"},
                class: "mb-2"
              }),
              _createVNode(_component_Skeleton, {
                width: "100%",
                style: {"height":"15rem"}
              })
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_Skeleton, {
                width: "100%",
                style: {"height":"2rem"},
                class: "mb-3"
              }),
              _createVNode(_component_Skeleton, {
                width: "100%",
                style: {"height":"10rem"},
                class: "mb-3"
              }),
              _createVNode(_component_Skeleton, {
                width: "100%",
                style: {"height":"10rem"}
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_Button, {
            class: "btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showForm = !_ctx.showForm)),
            "aria-label": "Toggle shorter sides"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Feedback")
            ]),
            _: 1
          })
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_26, [
          _createElementVNode("form", {
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleTestimonial && _ctx.handleTestimonial(...args)), ["prevent"])),
            ref: "testimonials"
          }, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_Dropdown, {
                    id: "title",
                    name: "title",
                    modelValue: _ctx.form.title,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.title) = $event)),
                    options: _ctx.partneredInnovationList,
                    optionLabel: "name",
                    optionValue: "name",
                    placeholder: "Select Innovation",
                    class: "w-100",
                    filter: true,
                    loading: _ctx.loading1
                  }, null, 8, ["modelValue", "options", "loading"])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createVNode(_component_Textarea, {
                  modelValue: _ctx.form.description,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.description) = $event)),
                  id: "description",
                  name: "description",
                  autoResize: true,
                  rows: "5",
                  cols: "30",
                  placeholder: "Enter text here...",
                  class: "w-100"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("span", _hoisted_34, [
                  _createVNode(_component_InputText, {
                    type: "text",
                    id: "author",
                    name: "author",
                    modelValue: _ctx.form.author,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.author) = $event)),
                    autocomplete: "author"
                  }, null, 8, ["modelValue"]),
                  _hoisted_35
                ])
              ])
            ]),
            _createVNode(_component_Button, {
              class: _normalizeClass(["btn", { submitting: _ctx.loading3 }]),
              type: "submit",
              disabled: _ctx.loading3
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Submit ")
              ]),
              _: 1
            }, 8, ["disabled", "class"])
          ], 544)
        ], 512), [
          [_vShow, _ctx.showForm === true]
        ])
      ])
    ])
  ]))
}